import LogIn from "containers/LogIn";
import PasswordChangeRequest from "containers/RecoverPassword";
import Dashboard from "containers/Dashboard";
import InventoryItems from "containers/InventoryItems";
import CustomerList from "containers/CustomerList";
import { Navigate, Route, Routes } from "react-router-dom";
import InventoryCategories from "containers/InventoryCategories";
import "./App.css";
import Page404 from "containers/Page404";
import { useRealmApp } from "RealmApp";
// import Register from "containers/LogIn/Register";
import InventoryVariants from "containers/InventoryVariants";
import InventoryModifiers from "containers/InventoryModifiers";
import Reservations from "containers/Reservations";
import ReportSales from "containers/ReportSales";
import ReportsPaymentMethods from "containers/ReportsPaymentMethods";
import ReportsCategories from "containers/ReportsCategories";
import ReportsTaxes from "containers/ReportsTaxes";
import EmployeesList from "containers/EmployeesList";
import OperationsSales from "containers/OperationsSales";
import OperationsEndOfDay from "containers/Operations";
import RestorePassword from "containers/RestorePassword";
import ReportsItems from "containers/ReportsItems";
import ReportCustomers from "containers/ReportsCustomers";
import ReportsEmployees from "containers/ReportsEmployees";
import InventoryPriceList from "containers/InventoryPriceList";
import ConfirmAccount from "./containers/ConfirmAccount";
import Page403 from "./containers/Page403";
import Page500 from "./containers/Page500";
import UpdaterAccountConfirm from "./containers/UpdaterAccountConfirm";
import UpdaterChangePassword from "./containers/UpdaterChangePassword";
import GeneralInfo from "./containers/SettingsGeneralInfo/index";
import StoreSettings from "./containers/SettingsStoreSettings/index";
import HolderData from "./containers/SettingsHolderData/index";
// import StoreHours from "./containers/SettingsStoreHours/index";
import SecuredContainer from "./components/SecuredContainer";
import { BusinessAppProvider } from "./BusinessApp";
import ClockSessions from "containers/ClockSessions";
import SettingsEditRooms from "containers/Rooms";
import { DatesProvider } from "./context/DatesContext";

function App() {
  const app = useRealmApp();
  const loggedIn = !!app.currentUser;
  if (!loggedIn) {
    return (
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route exact path="/login" element={<LogIn />} />
        {/* <Route exact path="/new_user" element={<Register />} /> */}
        <Route exact path="/confirmAccount" element={<ConfirmAccount />} />
        <Route
          exact
          path="/passwordChangeRequest"
          element={<PasswordChangeRequest />}
        />
        <Route exact path="/resetPassword" element={<RestorePassword />} />
        <Route
          path="/updaterAccountConfirm"
          element={<UpdaterAccountConfirm />}
        />
        <Route
          path="/updaterResetPassword"
          element={<UpdaterChangePassword />}
        />
        <Route path="/accessDenied" element={<Page403 />} />
        <Route path="/500" element={<Page500 />} />
        <Route path="*" element={<Page404 />} />
        {/* <Route path="*" element={<Navigate to="/accessDenied" />} /> */}
      </Routes>
    );
  }

  return (
    <DatesProvider>
      <BusinessAppProvider>
        <Routes>
          <Route path="/" element={<SecuredContainer />}>
            <Route path="" element={<Navigate to="dashboard" />} />
            <Route exact path="/login" element={<Navigate to="/dashboard" />} />
            <Route exact path="/dashboard" element={<Dashboard />} />
            <Route exact path="/reports/sales" element={<ReportSales />} />
            <Route
              exact
              path="/reports/payment_methods"
              element={<ReportsPaymentMethods />}
            />
            <Route
              exact
              path="/reports/categories"
              element={<ReportsCategories />}
            />
            <Route exact path="/reports/items" element={<ReportsItems />} />
            <Route exact path="/reports/taxes" element={<ReportsTaxes />} />

            <Route
              exact
              path="/reports/customers"
              element={<ReportCustomers />}
            />
            <Route
              exact
              path="/reports/employee"
              element={<ReportsEmployees />}
            />

            <Route exact path="/rooms" element={<SettingsEditRooms />} />

            <Route exact path="/inventory/items" element={<InventoryItems />} />
            <Route
              exact
              path="/inventory/categories"
              element={<InventoryCategories />}
            />
            <Route
              exact
              path="/inventory/modifiers"
              element={<InventoryModifiers />}
            />
            <Route
              exact
              path="/inventory/priceList"
              element={<InventoryPriceList />}
            />
            <Route
              exact
              path="/inventory/variants"
              element={<InventoryVariants />}
            />
            {/* Routes for the category of Customer */}
            <Route exact path="/customer/list" element={<CustomerList />} />
            {/* Routes for the category of workers */}
            <Route exact path="/employees/list" element={<EmployeesList />} />
            <Route
              exact
              path="/employees/schedules"
              element={<ClockSessions />}
            />
            <Route exact path="/employees/roles" element={<EmployeesList />} />
            <Route
              exact
              path="/operations/sales"
              element={<OperationsSales />}
            />
            <Route
              exact
              path="/operations/endofday"
              element={<OperationsEndOfDay />}
            />

            {/* End routes for the category of workers */}
            <Route exact path="/reservations" element={<Reservations />} />
            {/* Routes for settings */}
            <Route exact path="/settings/general" element={<GeneralInfo />} />
            <Route exact path="/settings/store" element={<StoreSettings />} />
            {/* <Route exact path="/settings/openHours" element={<StoreHours />} /> */}
            <Route exact path="/settings/owner" element={<HolderData />} />
            {/* End routes for settings */}
          </Route>

          <Route path="*" element={<Page404 />} />
          <Route exact path="/500" element={<Page500 />} />
        </Routes>
      </BusinessAppProvider>
    </DatesProvider>
  );
}

export default App;
